<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('closeModal')" />
    <div class="modal">
      <graph
        :title="adminText('workflowsAll.used_promocodes_49deee9', 'Used promocodes')"
        :has-data="true"
        :is-in-modal="true"
        @closeModal="$emit('closeModal')"
      >
        <pie-chart v-if="data.length" :data="workflowUi(chartData)" :options="workflowUi({ displayLegend: false })" />
        <div v-else class="noDataText">{{ adminText('workflowsAll.there_are_currently_no_tickets_sold_with_a_pr_9a53bc5', 'There are currently no tickets sold with a promo code.') }}</div>
      </graph>
      <div v-if="chartData" class="legend-container">
        <div v-for="dataItem in data" :key="dataItem.id" class="legend-item">
          <div style="display: flex; align-items: center">
            <div
              class="color-circle"
              :style="{
                background: colorsList[data.indexOf(dataItem)],
              }"
            />
            <span class="text-name">{{ workflowLabel(dataItem.name) }} {{ workflowLabel(getDiscount(dataItem)) }}</span>
          </div>
          <div class="separator" />
          <div style="display: flex">
            <span class="quantity">{{ workflowLabel(dataItem.sold) }}</span>
            <span
              class="text-initial-quantity"
            >/{{ workflowLabel(dataItem.unlimited ? adminText('workflowsAll.unlimited_e1a6f0b', 'unlimited') : getInitialQuantity(dataItem)) }}</span>
          </div>
        </div>
        <div
          v-if="chartData && data.some(item => !item.unlimited)"
          class="legend-item"
          style="margin-top: 0.75rem"
        >
          <div style="display: flex; align-items: center">
            <div class="color-circle" style="background: #f5f5f5" />
            <span class="text-name">{{ adminText('workflowsAll.total_limited_available_promo_codes_2d4b6bd', 'Total limited available promo codes') }}</span>
          </div>
          <div class="separator" />
          <div style="display: flex">
            <span class="quantity">{{
              workflowLabel(calculateLimitedTotalCount() - calculateLimitedSoldCount())
            }}</span>
            <span class="text-initial-quantity">/{{ workflowLabel(calculateLimitedTotalCount()) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import PieChart from '@/components/shared/graphs/pie-chart.vue'
import Graph from '@/components/shared/graphs/graph.vue'
export default {
  mixins: [WorkflowDisplay],
  name: 'sold-tickets-with-promo-code-modal',
  components: { Graph, PieChart },
  props: {
    data: Array,
    totalSold: { type: Number, default: 0 },
    promoCodes: { type: Array, default: () => [] },
    totalCount: { type: Number, default: 0 },
  },
  data() {
    return {
      colorsList: [
        '#0277BD',
        '#CEE4F2',
        '#6B02BD',
        '#B902BD',
        '#BD0202',
        '#BD5C02',
        '#988A14',
        '#0E7E1A',
        '#0F8890',
      ],
    }
  },
  computed: {
    chartData() {
      return {
        labels: this.data.map(item => item.name),
        datasets: [
          {
            label: 'workflowsAll.vrste_promo_kodova_eb04859',
            data: this.data.map(item => item.sold),
            backgroundColor: this.colorsList,
            hoverBackgroundColor: this.colorsList,
          },
        ],
      }
    },
  },
  methods: {
    getDiscount(item) {
      if (item.discountType === 'AMOUNT') {
        return `-${item.discountAmount} ${item.currency}`
      }

      return `-${item.discountPercentage} %`
    },
    getInitialQuantity(dataItem) {
      const promoCode = this.promoCodes.find(pc => pc.id === dataItem.id)

      return promoCode.ticketsPerOrder * dataItem.initialQuantity
    },
    calculateLimitedSoldCount() {
      return this.data.reduce((acc, curr) => (acc += curr.unlimited ? 0 : curr.sold), 0)
    },
    calculateLimitedTotalCount() {
      return this.data.reduce(
        (acc, curr) => (acc += curr.unlimited ? 0 : this.getInitialQuantity(curr)),
        0,
      )
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  position: relative;
  padding: 2rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  width: 42.75rem;
}
.modal::-webkit-scrollbar {
  display: none;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
.legend-container {
  overflow: auto;
  height: 200px;
}
.legend-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
}
.color-circle {
  width: 12px;
  height: 12px;
  border-radius: 10000px;
  margin-right: 0.5rem;
}
.separator {
  display: flex;
  height: 0.6875rem;
  padding: 0.5rem 0;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  border-bottom: 1px dotted #979797;
}
.text-name {
  color: #666;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.quantity {
  color: #666;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
  line-height: 100%;
  letter-spacing: -0.03rem;
}

.text-initial-quantity {
  color: #666;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 1.2rem */
  letter-spacing: -0.03rem;
}

.noDataText {
  height: 175px;
  margin-top: 150px;
  color: grey;
}
</style>
